import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineArrowRight } from 'react-icons/hi2';
import { BsBank2, BsHospital, BsCart4, BsGear, BsLightningCharge, BsBroadcast, BsTruck, BsBuildings, BsMortarboard } from 'react-icons/bs';

const IndustriesPage = () => {
  const industries = [
    { icon: <BsBank2 />, title: 'Financial Services', desc: 'AI-powered fraud detection, risk modeling, and automated compliance for banking, insurance, and capital markets.' },
    { icon: <BsHospital />, title: 'Healthcare & Life Sciences', desc: 'Accelerate drug discovery, optimize clinical trials, and personalize patient care with enterprise AI solutions.' },
    { icon: <BsCart4 />, title: 'Retail & E-Commerce', desc: 'Personalized recommendations, demand forecasting, and supply chain optimization to boost conversions and reduce costs.' },
    { icon: <BsGear />, title: 'Manufacturing', desc: 'Predictive maintenance, quality control automation, and smart factory solutions for Industry 4.0 transformation.' },
    { icon: <BsLightningCharge />, title: 'Energy & Utilities', desc: 'Grid optimization, predictive asset management, and sustainability analytics for modern energy companies.' },
    { icon: <BsBroadcast />, title: 'Telecommunications', desc: 'Network optimization, churn prediction, and customer experience enhancement through intelligent automation.' },
    { icon: <BsTruck />, title: 'Logistics & Supply Chain', desc: 'Route optimization, warehouse automation, and end-to-end supply chain visibility powered by AI.' },
    { icon: <BsBuildings />, title: 'Government & Public Sector', desc: 'Citizen services automation, data-driven policy making, and secure AI deployment for government agencies.' },
    { icon: <BsMortarboard />, title: 'Education & EdTech', desc: 'Adaptive learning platforms, student analytics, and AI-powered content generation for modern education.' },
  ];

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <div className="hero-text">
              <div className="section-label">Verticals</div>
              <h1>Industries We Serve</h1>
              <p>We bring deep domain expertise across industries, delivering AI solutions tailored to sector-specific challenges and regulations.</p>
            </div>
          </div>
        </div>
        <div className="hero-image-wrapper">
          <img
            src="/images/industries-hero.png"
            alt="Multi-Industry Digital AI Grid"
          />
        </div>
      </section>

      <section className="section section-dark">
        <div className="container">
          <div className="industries-grid">
            {industries.map((ind, i) => (
              <div className={`industry-card fade-in-up-delay${(i % 4) + 1}`} key={i}>
                <div className="industry-icon">{ind.icon}</div>
                <h3>{ind.title}</h3>
                <p>{ind.desc}</p>
                <Link to="/contact" className="learn-more" style={{ marginTop: 16, display: 'inline-flex' }}>
                  Learn More <HiOutlineArrowRight />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Don't see your industry?</h2>
            <p>Our AI solutions are adaptable. Let's discuss how we can serve your unique sector needs.</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn-primary">Book a Discovery Call <HiOutlineArrowRight /></Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default IndustriesPage;
